export function getFileType(extension: string | undefined): string | undefined {
  if (extension?.match(/^(png|jpg|jpeg|gif|bmp|webp|svg|ico|avif)$/i)) {
    return 'image';
  }

  if (extension === 'pdf') {
    return 'pdf';
  }

  return undefined;
}
